import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { createSafeContext } from '@coveord/plasma-mantine';
var _createSafeContext = _sliced_to_array(createSafeContext('PrerequisitesList component was not found in tree'), 2);
export var PrerequisitesListProvider = _createSafeContext[0], usePrerequisitesListContext = _createSafeContext[1];

//# sourceMappingURL=PrerequisitesList.context.js.map